import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatChipGrid, MatChipInput, MatChipInputEvent, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import {Observable} from 'rxjs';
import {of} from 'rxjs';
import {debounceTime, startWith, switchMap, tap} from 'rxjs/operators';
import {IProvider} from '../option-items-providers';
import { appearWidth, fadeInOut } from '../../rule/kyloe-animations';

export interface IChipItem {
  id: number;
  name: string;
}

@Component({
  selector: 'app-chip-list-autocomplete',
  templateUrl: './chip-list-autocomplete.component.html',
  animations: [appearWidth, fadeInOut],
  imports: [
    MatChipGrid,
    MatChipRow,
    ReactiveFormsModule,
    MatChipInput,
    MatChipRemove,
    MatInput,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
    MatIcon,
    NgForOf,
    NgIf,
    AsyncPipe
  ],
  styleUrls: ['./chip-list-autocomplete.component.scss']
})
export class ChipListAutocompleteComponent implements OnInit {
  @Input() valueControl: FormControl;

  toManyChipsControl: FormControl;
  selectedToManyMetas: IChipItem[] = [];
  toManyValues$: Observable<IChipItem[]>;
  searching = false;

  private itemsProvider: IProvider<IChipItem>;

  ngOnInit() {
    this.toManyChipsControl = new FormControl({value: '', disabled: false});

    this.toManyValues$ = this.toManyChipsControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      tap(_ => this.searching = true),
      switchMap(value => this.itemsProvider ? this.itemsProvider.filter(value) : of([])),
      tap(_ => this.searching = false),
      tap(result => console.log(`clacc.items.valueChange results`, result.length))
      );
  }

  setItemsProvider(itemsProvider: IProvider<IChipItem>, selItems?: IChipItem[]): void {
    this.itemsProvider = itemsProvider;
    this.selectedToManyMetas = selItems ? [...selItems] : [];
  }

  clearItems(): void {
    this.valueControl.setValue([]);
    this.selectedToManyMetas = [];
    this.toManyChipsControl.setValue('');
  }

  loading(): void {
   this.toManyChipsControl.disable();
  }

  loadComplete(): void {
    this.toManyChipsControl.enable();
  }

  toManySelected(e: MatAutocompleteSelectedEvent): void {
    const currentValue = this.valueControl.value;
    const newValue = currentValue ? [...currentValue, e.option.value] : [e.option.value];
    this.valueControl.setValue(newValue);
    this.valueControl.markAsDirty();

    const sel = this.itemsProvider.get(e.option.value);
    this.selectedToManyMetas.push(sel);

    this.toManyChipsControl.setValue('');
  }

  addInValue(event: MatChipInputEvent): void {
    if (event.value) {
      // TODO: find the matching toManyMetas value and do everything toManySelected does if a match is found
      event.input.value = '';
      this.valueControl.markAsDirty();
    } else {
      // resetting the value causes the full list to get displayed when click in input
      this.toManyChipsControl.setValue('');
    }
  }

  removeInValue(val: number): void {
    const values = this.valueControl.value;
    const index = values.indexOf(val);
    if (index > -1) {
      values.splice(index, 1);
      this.selectedToManyMetas.splice(index, 1);
      this.valueControl.setValue(values);
      this.valueControl.markAsDirty();
    }
  }

  toManyDisplay(id: number): string {
    const meta: IChipItem = this.itemsProvider ? this.itemsProvider.get(id) : null;
    return meta ? meta.name : '';
  }

  forceShowToManyDropDown(event): void {
    event.target.blur();
    event.target.focus();
  }
}
